import { config } from "../../../lib/config";

export const envName = `${config.envName}-${config.contracts.protocolDiamond}`;
